module.exports = __webpack_public_path__ + "static/media/example-1.37b04436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BusinessNews/example-1.jpg
// module id = 275
// module chunks = 0